import { Component, OnInit, Input, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { UiLoadingModel } from '../../models/UiLoadingModel';

@Component({
    selector: '.ui-loading',
    templateUrl: './loading.component.html',
    styleUrls: ['./loading.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoadingComponent implements OnInit {

  @Input() model: UiLoadingModel;

  constructor() { }

  ngOnInit(): void {
  }

}
